import React from 'react'

export default function({ onChange, onSubmit }) {
  return React.useCallback(
    (values, form) => {
      const {
        active,
        errors,
        invalid,
        touched,
      } = form.getState()

      // If we do not blur a field and press 'enter' to submit form:
      // Firstly, we have to change state
      onChange({
        values,
        invalid,
        active: active || null,
        touched,
        errors,
      })

      // Start the next checkout step only from a valid final-form submit.
      if (!invalid) {
        onSubmit(values)
      }
    },
    [onChange, onSubmit],
  )
}
